package com.meistercharts.charts.pv.stringsPlanning

import com.meistercharts.canvas.interaction.InteractionState
import com.meistercharts.charts.pv.roofPlanning.Module

/**
 * Projects the interaction state of the strings planning onto what the paint code needs to know.
 *
 * This is the only place that knows the interaction state; painting asks these two questions per module.
 */

/**
 * Returns the string whose color fills the given module, or null if the module is not part of the string currently
 * being planned.
 */
fun InteractionState<Module>.plannedStringOf(module: Module, model: PvStringsPlanningModel): RoofString? {
  return model.selectedString?.takeIf { it.contains(module) }
}

/**
 * Returns true if the given module is highlighted because the mouse is over it.
 */
fun InteractionState<Module>.isHovered(module: Module): Boolean {
  return hoveredElement == module
}
